/* eslint-disable @typescript-eslint/no-explicit-any */
import useSWR from 'swr';
import { combinedProducts } from '../config/settings';
import {
  shopifyPredictiveSearchToProductHandles,
  shopifyProdToProduct,
} from '../utils/shopify.utils';
import {
  ShopifyOrderData,
  ShopifyCartUpdateData,
  Product,
  ShopifyProduct,
  ShopifyPredictiveSearch,
} from '../utils/types';
import { get, post } from './requests';

export const getCart = async () => {
  try {
    const url = '/cart.js';
    const response = await get(url);
    return response;
  } catch (err: any) {
    throw new Error(err);
  }
};

export const updateCart = async (updates: ShopifyCartUpdateData) => {
  try {
    const url = '/cart/update.js';
    const response = await post(url, updates);
    return response;
  } catch (err: any) {
    throw new Error(err);
  }
};

export const addToCart = async (products: ShopifyOrderData) => {
  try {
    const url = '/cart/add.js';
    const response = await post(url, products);
    return response;
  } catch (err: any) {
    throw new Error(err);
  }
};

export const getProduct = (handle: string): Product => {
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const { data, error } = useSWR<ShopifyProduct>(`/products/${handle}.js`, get);
  if (error) throw new Error(error);
  const prod = shopifyProdToProduct(data);

  if (combinedProducts[handle]) {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const { data: combinedProduct } = useSWR<ShopifyProduct>(
      `/products/${combinedProducts[handle]}.js`,
      get
    );
    prod.price = (prod.price || 0) + (combinedProduct?.price || 0);
  }

  return prod;
};

export const ShopifyProductSearch = ({
  parentType,
  productType,
  needsPrescription = false,
}: {
  parentType: string;
  productType: string;
  needsPrescription?: boolean;
}): string[] => {
  const { data, error } = useSWR<ShopifyPredictiveSearch, Error>(
    `/search/suggest.json?q=${productType}&resources[type]=product`,
    get
  );
  if (error) throw error;
  const productHandles = shopifyPredictiveSearchToProductHandles(
    data,
    parentType,
    productType,
    needsPrescription
  );
  return productHandles;
};
